// extracted by mini-css-extract-plugin
export default {"selectCustomer":"DocumentsTableBody_selectCustomer__fUTlj","row":"DocumentsTableBody_row__4ij7l"};